// src/constants.ts
//
// Общие константы фронтенда.
//
// MAX_PUBLIC_DOWNLOADS — лимит публичных скачиваний заключения по умолчанию.
// Источник истины — backend/app/routers/results.py (MAX_PUBLIC_DOWNLOADS).
// Значение здесь используется только как подстраховка (fallback), если API
// по какой-то причине не вернул поле download_limit. Менять синхронно с бэком.
export const MAX_PUBLIC_DOWNLOADS = 3;

/** Публичная оферта размещена на сайте Psydecrypt Online. */
export const OFFER_URL = 'https://psydecrypt.online/';

/** Скрытый путь входа администратора (не показывается в интерфейсе). */
export const ADMIN_LOGIN_PATH = '/psd-entry-siberianivolga-crypt';

/** Максимальный размер архива БД для импорта, байты. Источник истины —
 *  backend/app/routers/db_transfer.py (MAX_IMPORT_BYTES). */
export const MAX_IMPORT_BYTES = 200 * 1024 * 1024;

/** Допустимые значения персонального лимита скачиваний в админке (0 = запрет). */
export const DOWNLOAD_LIMIT_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;
